import currentPartner from '../constants/partners';
import localStorage from './localStorage';

const SESSION_PARTNER_BASE_PATH = 'SESSION_PARTNER_BASE_PATH';

// An empty base path means the session belongs to the app without a partner.
export const saveSessionPartner = () => {
  localStorage.set(SESSION_PARTNER_BASE_PATH, currentPartner?.basePath ?? '');
};

export const clearSessionPartner = () => {
  localStorage.remove(SESSION_PARTNER_BASE_PATH);
};

/**
 * Sends a logged-in user who opened a link for another app (another partner,
 * or with or without a partner) back to the app their session belongs to,
 * since the partner is only known from the URL.
 *
 * @returns true if a redirect was started
 */
export const redirectToSessionPartner = (isUserLoggedIn?: boolean): boolean => {
  const basePath = localStorage.get<string>(SESSION_PARTNER_BASE_PATH);
  const currentBasePath = currentPartner?.basePath ?? '';

  if (basePath === null) {
    return false;
  }

  if (!isUserLoggedIn) {
    clearSessionPartner();
    return false;
  }

  if (basePath === currentBasePath) {
    return false;
  }

  const { pathname, search } = window.location;
  const path = `${basePath}${pathname.slice(currentBasePath.length)}` || '/';
  window.location.replace(`${path}${search}`);
  return true;
};
